import {React} from 'react';
import { Button, Typography, useTheme } from '@mui/material';

const ButtonCancel = ({
  size='lg',
  variant='outlined',
  action,
}) => {
  const theme = useTheme();
  return (
    <Button
      variant={variant}
      onClick={action}
      sx={{
        width: size === 'lg' ? theme.spacing(12) : theme.spacing(10),
        height: size === 'lg' ? theme.spacing(6) : theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.neutral[200],
        p: 1,
        px: size === 'lg' ? 3 : 2
      }}
    >
      { size === 'lg' ? 
        <Typography variant='body2' sx={{fontWeight: 500, color: theme.palette.neutral[600]}}>Cancel</Typography>:
        <Typography variant='subtitle1' sx={{ color: theme.palette.neutral[600] }}>Cancel</Typography>
      }
    </Button>
  );
};

export default ButtonCancel;